import useCloseOverlay from '@/hooks/useCloseOverlay';

import { type LoginMenuProps } from './LoginMenu.types';

const LoginMenu: React.FC<LoginMenuProps> = ({ onClickOutside, loginMenu }) => {
  // setup click handler for when login menu is open, to be able to close it when
  // the user clicks outside of it
  useCloseOverlay(['header__login'], onClickOutside);

  return (
    <div className="header__login--menu">
      <ul>
        {loginMenu.map((link, i) => {
          const { title, url, isNewWindow } = link;

          return (
            <li key={i} className="header__login--menu__item">
              <a href={url} target={isNewWindow && '_blank'}>
                {title}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LoginMenu;
